// ─── MissionVision.jsx ───────────────────────────────────────────────────────

import { Box, Typography } from "@mui/material";

export default function MissionVision() {
  return (
    <Box
      id="mission"
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
      }}
    >
      {/* ── Mission — 10% brown side ── */}
      <Box
        sx={{
          bgcolor: "#5C3311",              // 10% brown — primary
          py: { xs: 8, md: 12 },
          px: { xs: 4, md: 8 },
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Ghost letter — warm white tint */}
        <Box
          sx={{
            position: "absolute", right: -16, bottom: -40,
            fontFamily: "'Playfair Display', serif",
            fontSize: "220px", fontWeight: 900,
            color: "rgba(255,255,255,0.06)",
            lineHeight: 1, pointerEvents: "none", userSelect: "none",
          }}
        >
          M
        </Box>

        <Box sx={{ position: "relative", zIndex: 1 }}>
          {/* Eyebrow — matches site pattern */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 4 }}>
            <Box sx={{ width: 24, height: 2, bgcolor: "#DDA63A", borderRadius: 1 }} />
            <Typography
              sx={{
                fontSize: "11px", fontWeight: 700,
                letterSpacing: "3px", textTransform: "uppercase",
                color: "#DDA63A",
              }}
            >
              Our Mission
            </Typography>
          </Box>

          {/* Opening quote mark */}
          <Typography
            sx={{
              fontFamily: "'Playfair Display', serif",
              fontSize: "96px",
              color: "rgba(221,166,58,0.35)",  // gold — brand accent
              lineHeight: 0.6,
              mb: 3,
              display: "block",
            }}
          >
            "
          </Typography>

          <Typography
            sx={{
              fontFamily: "'Playfair Display', serif",
              fontSize: { xs: "22px", md: "27px" },
              fontWeight: 700,
              color: "#fff",
              lineHeight: 1.5,
            }}
          >
            To build sustainable, affordable, and climate-resilient shelters
            while empowering African communities to thrive for generations to come.
          </Typography>
        </Box>
      </Box>

      {/* ── Vision — 30% cream side ── */}
      <Box
        sx={{
          bgcolor: "#F5EDE0",              // 30% cream — secondary
          py: { xs: 8, md: 12 },
          px: { xs: 4, md: 8 },
          borderTop: { xs: "4px solid #5C3311", md: "none" },
          borderLeft: { md: "4px solid #5C3311" },  // left rule ties the two panels
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Ghost letter — brown tint on cream */}
        <Box
          sx={{
            position: "absolute", right: -16, bottom: -40,
            fontFamily: "'Playfair Display', serif",
            fontSize: "220px", fontWeight: 900,
            color: "rgba(92,51,17,0.05)",   // brown ghost — not green
            lineHeight: 1, pointerEvents: "none", userSelect: "none",
          }}
        >
          V
        </Box>

        <Box sx={{ position: "relative", zIndex: 1 }}>
          {/* Eyebrow */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 4 }}>
            <Box sx={{ width: 24, height: 2, bgcolor: "#5C3311", borderRadius: 1 }} />
            <Typography
              sx={{
                fontSize: "11px", fontWeight: 700,
                letterSpacing: "3px", textTransform: "uppercase",
                color: "#5C3311",
              }}
            >
              Our Vision
            </Typography>
          </Box>

          {/* Opening quote mark */}
          <Typography
            sx={{
              fontFamily: "'Playfair Display', serif",
              fontSize: "96px",
              color: "rgba(92,51,17,0.2)",   // brown — not green
              lineHeight: 0.6,
              mb: 3,
              display: "block",
            }}
          >
            "
          </Typography>

          <Typography
            sx={{
              fontFamily: "'Playfair Display', serif",
              fontSize: { xs: "22px", md: "27px" },
              fontWeight: 700,
              color: "#1a0a00",              // rich dark text on cream
              lineHeight: 1.5,
            }}
          >
            Contributing to the UN SDGs and Agenda 2063 for{" "}
            <Box
              component="em"
              sx={{ fontStyle: "normal", color: "#5C3311" }}  // brown — not green
            >
              "The Africa We Want"
            </Box>{" "}
            — where every person has a safe home, clean energy, and access to education.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}